import Hero from "@/components/Hero";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Programs from "@/components/Programs";
import Partners from "@/components/Partners";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <Gallery />
      <Programs />
      <Partners />
    </div>
  );
}
